<script>
/**
 * Prices for every platform (GPS, COOP, SUPERDRUG, …), edited on the Pricing page.
 * Endpoints: GET / PUT /api/admin/pricing (admin sign-in required). All amounts are GBP in pounds
 * (not pence), or null; drugMarkupFactor is a ratio (0.2 = 20%).
 */
const PricingService = {};

PricingService.install = function (Vue) {
  const service = {};
  Object.defineProperty(Vue.prototype, '$pricingService', { value: service });

  const base = '/api/admin/pricing';
  const data = response => (response.data && response.data.data !== undefined ? response.data.data : response.data);

  /** Cached promise of the GPS row (or null when the call failed), so other pages don't call the API repeatedly. */
  let gpsPromise = null;

  const gpsRow = list => (Array.isArray(list) ? list.find(p => p && p.platformId === 'GPS') || null : null);

  service.errorMessage = function (error, fallback) {
    const body = error && error.response && error.response.data;
    if (body && typeof body.message === 'string' && body.message) {
      return body.message;
    }
    return fallback || 'Something went wrong. Please try again.';
  };

  /** 401: the admin's session has expired (or was signed out elsewhere). */
  service.isSignedOut = function (error) {
    return !!(error && error.response && error.response.status === 401);
  };

  /** Resolves PlatformPricing[]. */
  service.list = function () {
    return Vue.axios.get(base).then(data).then(list => {
      gpsPromise = Promise.resolve(gpsRow(list));
      return list;
    });
  };

  /** payload: PlatformPricing[] (changed platforms only is fine). Resolves the fresh PlatformPricing[]. */
  service.save = function (payload) {
    return Vue.axios.put(base, payload).then(data).then(list => {
      gpsPromise = Promise.resolve(gpsRow(list));
      return list;
    });
  };

  /** Field errors from a 400, keyed "GPS.appointmentPreAuthPrice" → message. */
  service.fieldErrors = function (error) {
    const body = error && error.response && error.response.data;
    return (body && body.data && body.data.fields) || {};
  };

  /**
   * Who changed which price, newest first. params: { page, size, platformId? }.
   * Resolves { items: [{ id, changedAt, adminId, adminName, adminEmail, platformId, platformName, field, fieldLabel, oldValue, newValue, changeGroup }], total, page, size }.
   */
  service.activity = function (params) {
    return Vue.axios.get(base + '/activity', { params: params || {} }).then(data);
  };

  /** Resolves the GPS PlatformPricing row, or null if it could not be loaded (callers keep their own fallback). */
  service.getGpsPricing = function () {
    if (!gpsPromise) {
      gpsPromise = Vue.axios.get(base).then(data).then(gpsRow).catch(() => {
        gpsPromise = null; // try again next time
        return null;
      });
    }
    return gpsPromise;
  };

  /** Resolves one GPS price as a number, or `fallback` when it is missing or the call failed. Never rejects. */
  service.gpsPrice = function (field, fallback) {
    return service.getGpsPricing().then(row => {
      const value = row ? row[field] : null;
      return value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Number(value) : fallback;
    }).catch(() => fallback);
  };
};

export default PricingService;
</script>
